<template>
  <d-container fluid class="main-content-container px-4">
    <d-row no-gutters class="page-header py-4">
      <div class="col-12 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle d-block">Banco de Perguntas</span>
        <h3 class="page-title d-inline">
          <span class="text-primary">{{ word ? word.word : '...' }}</span>
        </h3>
      </div>
    </d-row>

    <d-row>
      <d-col>
        <d-card class="card-small mb-4">
          <div class="card-header border-bottom d-flex justify-content-between align-items-center">
            <div class="col-6">
              <h6 class="m-0">Perguntas</h6>
            </div>

            <div class="col-2 d-flex">
              <div class="input-group">
                <d-select
                  v-model="pagination.level"
                  :options="levelFilters"
                  value-field="slug"
                  text-field="label"
                />
              </div>
            </div>

            <div class="col-2 text-right">
              <button class="btn btn-success btn-sm text-white" @click="addNewRow">
                <i class="fas fa-plus mr-1" /> Nova Pergunta
              </button>
            </div>
          </div>

          <div class="card-body p-0 pb-3 text-left">
            <div class="table-overflow">
              <question-table
                :questions="questionsList"
                :word-id="word ? word.id : null"
                :levels="levels"
                @saved="onSaved"
                @deleted="onDeleted"
                @add-row="addNewRow"
              />
            </div>
            <pagination
              :total-items="totalItems"
              :pagination.sync="pagination"
            />
          </div>
        </d-card>
      </d-col>
    </d-row>

    <confirmation-modal
      :cancel="closeDeleteModal"
      :confirm="executeDeleteQuestion"
      title="Excluir Pergunta"
      message="Tem certeza que deseja excluir esta pergunta do sistema permanentemente?"
    />
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import WordService from '_services/rest/modules/word';
import PuzzleService from '_services/rest/modules/puzzle';
import Events from '_utils/events';
import Pagination from '_shared/Pagination.vue';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import QuestionTable from '../components/QuestionTable.vue';

export default {
  name: 'question-list',
  components: { Pagination, ConfirmationModal, QuestionTable },
  data() {
    return {
      word: null,
      questionsList: [],
      totalItems: 0,
      questionToDelete: null,
      pagination: {
        page: 1,
        take: 10,
        skip: 0,
        level: null,
      },
      levels: [
        { slug: 'easy', label: 'Fácil' },
        { slug: 'medium', label: 'Médio' },
        { slug: 'hard', label: 'Difícil' },
      ],
      levelFilters: [
        { slug: null, label: 'Filtro por nível' },
        { slug: 'easy', label: 'Fácil' },
        { slug: 'medium', label: 'Médio' },
        { slug: 'hard', label: 'Difícil' },
      ],
    };
  },
  methods: {
    ...mapActions(['setToggle', 'activeAlert']),
    fetchWordData(id) {
      this.word = null;
      this.questionsList = [];

      WordService.getWordById(id, this.pagination)
        .then(response => {
          this.word = response;
          this.questionsList = response.questions ? [...response.questions] : [];
          this.totalItems = response.total_questions || this.questionsList.length;
        })
        .catch(() => {
          this.activeAlert({ message: 'Erro ao carregar a palavra', theme: 'danger' });
        });
    },
    addNewRow() {
      if (!this.word) return;
      this.questionsList.push({
        id: null,
        word_id: this.word.id,
        question: '',
        size_id: 3,
        level: this.pagination.level || 'medium',
        isNew: true,
      });
    },
    onSaved(savedRow, response) {
      savedRow.id = response.id;
      savedRow.isNew = false;
    },
    onDeleted(row) {
      this.questionToDelete = row;
      if (!row.id) {
        this.questionsList.splice(this.questionsList.indexOf(row), 1);
        this.questionToDelete = null;
        return;
      }
      this.setToggle({ type: 'confirm_modal', bool: true });
    },
    closeDeleteModal() {
      this.setToggle({ type: 'confirm_modal', bool: false });
      this.clearDeleteState();
    },
    clearDeleteState() {
      this.questionToDelete = null;
      this.indexToDelete = null;
    },
    executeDeleteQuestion() {
      if (!this.questionToDelete) return;
      PuzzleService.deleteQuestion(this.questionToDelete.id)
        .then(() => {
          this.questionsList.splice(this.questionsList.indexOf(this.questionToDelete), 1);
          this.totalItems -= 1;
          this.activeAlert({ message: 'Pergunta excluída!', theme: 'success' });
          this.questionsList.splice(this.indexToDelete, 1);
          this.closeDeleteModal();
        })
        .catch(() => {
          this.activeAlert({ message: 'Erro ao deletar.', theme: 'danger' });
          this.closeDeleteModal();
        });
    },
  },
  mounted() {
    Events.$on('update:pagination', pagination => {
      this.pagination.skip = (pagination.page - 1) * this.pagination.take;
      this.pagination.page = pagination.page;
      this.fetchWordData(this.$route.params.wordId);
    });

    if (this.$route.params.wordId) {
      this.fetchWordData(this.$route.params.wordId);
    }
  },
  destroyed() {
    Events.$off('update:pagination');
  },
};
</script>
